// src/Redux/Actions/productActions.js
import axios from "axios";


import {
  FETCH_PRODUCTS_REQUEST,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  ADD_PRODUCT,
  ADD_SUB_PRODUCT,
  ADD_SUB_PRODUCT_ERROR
} from "../ActionTypes/productVActionTypes";

// Action pour récupérer les produits


export const fetchProducts = () => async (dispatch) => {
  dispatch({ type: FETCH_PRODUCTS_REQUEST });

  try {
    const response = await axios.get("/api/ProductV/getAllProductsV"); // Vous devez avoir une API qui fournit ces produits
    dispatch({
      type: FETCH_PRODUCTS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_PRODUCTS_FAILURE,
      payload: error.message,
    });
  }
};



// Action pour ajouter un produit
export const addProduct = (product) => {
  return {
    type: ADD_PRODUCT,
    payload: product,
  };
};


// Action pour ajouter un sous-produit à un produit
export const addSubProduct = (productId, subProduct) => {
  return async (dispatch) => {
    try {
      // Appel API pour ajouter le sous-produit
      const response = await axios.post(`/api/ProductV/${productId}/subproductV`, subProduct);

      // Dispatch de l'action en cas de succès
      dispatch({
        type: ADD_SUB_PRODUCT,
        payload: {
          productId,
          subProduct: response.data, // Supposons que l'API retourne le sous-produit ajouté
        },
      });

      console.log("Sous-produit ajouté avec succès :", response.data);
    } catch (error) {
      console.error("Erreur lors de l'ajout du sous-produit :", error);

      // Dispatch d'une action d'erreur
      dispatch({
        type: ADD_SUB_PRODUCT_ERROR,
        payload: {
          productId,
          error: error.response?.data?.error || "Erreur interne du serveur.",
        },
      });
    }
  };
};
